import wretchAdapter from '@/shared/api/adapters/wretch';

export default wretchAdapter(CONFIG.WORK_TAGS);
